import { getLocalStorage, saveInLocalStorage } from 'src/shared/helpers/storageHelpers';
import { StreamEntity } from 'src/shared/StreamEntity';
export var removeStreamFromStorage = function () {
    var _a;
    // We must get again local storage because it was updated
    var recentLocalStreamRunning = (_a = getLocalStorage()) === null || _a === void 0 ? void 0 : _a.streamRunning;
    var streamFiltered = recentLocalStreamRunning.filter(function (streamRunningItem) { return !StreamEntity.streamRunning.some(function (item) { return item.id === streamRunningItem.id; }); });
    saveInLocalStorage({ streamRunning: streamFiltered });
};
